import { useEffect, useRef, useState } from "react"
import { Box, IconButton, Grid, Paper, Typography, Stack } from "@mui/material"
import VisibilityIcon from "@mui/icons-material/Visibility"
import ShopIcon from "@mui/icons-material/Shop"
import PreviewIcon from "@mui/icons-material/Preview"
import confetti from "canvas-confetti"
import { useNavigate } from "react-router-dom"

import { useApiService } from "../hooks/Api/useApiService"
import useError from "../hooks/Error/useError"
import UserSection from "../Marketplace/UserSection/UserSection"
import ChatModal from "../Modals/ChatModal/ChatModal"
import ViewSkillModal from "../Modals/ViewSkillModal/ViewSkillModal"

const SearchResultItem = ({ skill_data }) => {
  const { postData } = useApiService()
  const { Error: AlertError, error, success } = useError()
  const navigate = useNavigate()

  const viewRef = useRef()
  const chatRef = useRef()

  const [user, setUser] = useState(null)

  // Fetch user info
  useEffect(() => {
    postData("users/getuser", { user_name: skill_data.user_name })
      .then((data) => {
        setUser({ ...data?.user?.[0], remove_rating: true })
      })
      .catch(() => setUser(null))
  }, [skill_data.user_name])

  const handleConfetti = () => {
    confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 } })
  }

  const openViewSkillModal = () => viewRef.current?.childFunction()
  const openChatModal = () => chatRef.current?.childFunction()

  const openViewGroup = () => {
    navigate("/groups", { state: { skill: skill_data } })
  }

  const sendTransaction = async () => {
    try {
      const response = await postData("transactions/addtransaction", {
        skill_data,
        from: localStorage.getItem("user"),
        is_group: Boolean(skill_data.max_participants),
      })

      if (response.message === "Failed") {
        error("Transaction Already Exists!")
      } else {
        handleConfetti()
        success("Transaction Sent Successfully!")
      }
    } catch (err) {
      error(err.message)
    }
  }

  return (
    <>
      {/* Modals */}
      <ViewSkillModal ref={viewRef} skill={skill_data} />
      <ChatModal
        ref={chatRef}
        chat_user={localStorage.getItem("user")}
        to={skill_data.user_name}
        skill={skill_data}
      />

      {/* Main Skill Item */}
      <Paper
        elevation={3}
        sx={{
          p: 2,
          mb: 2,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(6, 1fr)",
          },
          gap: 1,
          alignItems: "center",
        }}
      >
        <Typography>{skill_data.name}</Typography>
        <Typography>{skill_data.cost} credit</Typography>
        <Typography>{skill_data.location}</Typography>
        <Typography>{skill_data.duration}</Typography>

        {/* User Info */}
        <Box>{user ? <UserSection user={user} /> : <Typography>Loading...</Typography>}</Box>

        {/* Actions */}
        <Stack direction='row' spacing={1}>
          {!skill_data.max_participants ? (
            <>
              <IconButton onClick={openViewSkillModal} aria-label='view skill'>
                <VisibilityIcon color='primary' />
              </IconButton>
              <IconButton onClick={sendTransaction} aria-label='purchase'>
                <ShopIcon color='secondary' />
              </IconButton>
            </>
          ) : (
            <IconButton onClick={openViewGroup} aria-label='view group'>
              <PreviewIcon color='primary' />
            </IconButton>
          )}
        </Stack>
      </Paper>

      <AlertError />
    </>
  )
}

export default SearchResultItem
